import { useState, useEffect, useCallback } from 'react'
import { useAuth } from '../context/AuthContext'
import { fetchAllHealth } from '../services/api'
import HealthOrb from './HealthOrb'
import { products } from '../data/milestones'

const serviceList = [
  { key: 'rafiq',   label: 'رفيق',  productKey: 'rafiq' },
  { key: 'muwafaq', label: 'موافق', productKey: 'muwafaq' },
  { key: 'sahha',   label: 'صحة',   productKey: 'sahha' },
]

const statusLabels = {
  healthy: 'يعمل',
  degraded: 'بطيء',
  down: 'متوقف',
}

export default function HealthBar() {
  const { token } = useAuth()
  const [health, setHealth] = useState({ rafiq: null, muwafaq: null, sahha: null })
  const [loading, setLoading] = useState(true)
  const [lastRefresh, setLastRefresh] = useState(null)
  const [spinning, setSpinning] = useState(false)

  const loadHealth = useCallback(async () => {
    try {
      const data = await fetchAllHealth(token)
      setHealth(data)
      setLastRefresh(new Date())
    } catch {
      // keep previous state
    } finally {
      setLoading(false)
    }
  }, [token])

  useEffect(() => {
    loadHealth()
    const interval = setInterval(loadHealth, 30000)
    return () => clearInterval(interval)
  }, [loadHealth])

  const handleRefresh = () => {
    setSpinning(true)
    loadHealth().finally(() => {
      setTimeout(() => setSpinning(false), 400)
    })
  }

  const timeStr = lastRefresh
    ? lastRefresh.toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' })
    : '--:--'

  return (
    <div className="glass rounded-[14px] px-6 py-4 flex items-center justify-between flex-wrap gap-3">
      {/* Service health indicators */}
      <div className="flex items-center gap-5 flex-wrap">
        {serviceList.map(s => {
          const h = health[s.key]
          const status = h?.status || 'down'
          const prod = products[s.productKey]
          return (
            <div key={s.key} className="flex items-center gap-2">
              <HealthOrb
                status={status}
                size="sm"
                ariaLabel={`${s.label}: ${statusLabels[status]}`}
              />
              <span className="text-sm font-medium text-[#94A3B8]">{s.label}</span>
              <span
                className="text-xs font-medium"
                style={{
                  color: status === 'healthy' ? '#22C55E' : status === 'degraded' ? '#F59E0B' : '#EF4444',
                }}
              >
                {statusLabels[status]}
              </span>
            </div>
          )
        })}
      </div>

      {/* Last refresh + refresh button */}
      <div className="flex items-center gap-3">
        <span className="text-xs text-[#475569]">آخر تحديث: {timeStr}</span>
        <button
          onClick={handleRefresh}
          className="p-2 rounded-lg bg-white/[0.04] hover:bg-white/[0.08] text-[#64748B] hover:text-[#F1F5F9] transition-all duration-150 active:scale-95"
          aria-label="تحديث حالة الخدمات"
        >
          <svg
            className={`w-4 h-4 transition-transform duration-400 ${spinning ? 'rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
      </div>
    </div>
  )
}
